import { render, staticRenderFns } from "./AddSpecificAnchorsModal.vue?vue&type=template&id=6c4c9e22&"
import script from "./AddSpecificAnchorsModal.vue?vue&type=script&lang=js&"
export * from "./AddSpecificAnchorsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports